import styled from 'styled-components'

export const ThreadColumnStyled = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.typography.pxToRem(12)};
  height: 100%;
  padding: ${(props) => props.theme.typography.pxToRem(12)}
    ${(props) => props.theme.space.medium}
    ${(props) => props.theme.space.medium};
`

export const ThreadViewportStyled = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`

// Scrollbar hidden; the edge fades and jump-to-latest button signal overflow.
export const ThreadScrollStyled = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.typography.pxToRem(20)};
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const ThreadEdgeShadowStyled = styled.div<{ $edge: 'top' | 'bottom' }>`
  position: absolute;
  left: 0;
  right: 0;
  ${(props) => props.$edge}: 0;
  height: ${(props) => props.theme.typography.pxToRem(40)};
  pointer-events: none;
  background: linear-gradient(
    ${(props) => (props.$edge === 'top' ? 'to bottom' : 'to top')},
    ${(props) => props.theme.colors.white},
    transparent
  );
`

export const ScrollToLatestButtonStyled = styled.button`
  position: absolute;
  bottom: ${(props) => props.theme.typography.pxToRem(12)};
  left: 50%;
  transform: translateX(-50%);
  width: ${(props) => props.theme.typography.pxToRem(32)};
  height: ${(props) => props.theme.typography.pxToRem(32)};
  border-radius: 50%;
  border: none;
  background: ${(props) =>
    props.theme.colors.button.primary.background.default};
  color: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(17, 24, 39, 0.15);

  &:hover {
    background: ${(props) =>
      props.theme.colors.button.primary.background.hover};
  }
`
